import { ref } from 'vue';
import { PlanNickName } from '@/entities/plan/constants';
import { emptyBillingDetails } from '@/entities/subscription/model';

export const planFrequency = ref<PlanNickName>(PlanNickName.Yearly);
export const numberSeats = ref<number>(1);
export const billingDetailsModel = ref(emptyBillingDetails());
export const contactSalesModal = ref<boolean>(false);
export const asynchronousAuthorization = ref<boolean>(false);
export const isContactingStripe = ref(false);
